module.exports = __webpack_public_path__ + "static/media/peepoSMASH.3cc4dfb0.gif";